import Modal from "@via/components/modal.tsx";
import { useDeleteRun } from "@via/pages/projects/runs/runs.api.tsx";
import { ModalSize } from "@via/utils/constants.tsx";
import { useGlobal } from "@via/hooks/useGlobal.tsx";
import { useNavigate } from "react-router-dom";

interface DeleteRunModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  runName: string;
  runId: string;
}

const DeleteRunModal = ({
  open,
  setOpen,
  runName,
  runId,
}: DeleteRunModalProps) => {
  const { selectedProject } = useGlobal();
  const navigate = useNavigate();
  const { mutateAsync: deleteRun, isPending: isDeleteRunLoading } =
    useDeleteRun();

  // Resolving closes the modal, and a rejection leaves it open with the mutation's own
  // error notification on screen. Awaiting the delete is what makes those two cases
  // distinguishable; the modal used to await a promise that never settled and close
  // itself from an isSuccess effect instead, which reported the same thing either way.
  const handleConfirmModal = async (): Promise<void> => {
    await deleteRun(runId);
    if (selectedProject?.id) {
      navigate(`/projects/${selectedProject.id}/runs`);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Delete Run"
      confirmText="Confirm Delete"
      size={ModalSize.Large}
      onCancel={handleCancel}
      isConfirmLoading={isDeleteRunLoading}
      onConfirm={handleConfirmModal}>
      <form>
        <div className="mt-0">
          <div className="mb-4 text-sm text-gray-600">
            Are you sure you want to delete the run named{" "}
            <span className="font-semibold">{runName}</span>?
            <p className="py-2">
              This action cannot be undone after it is completed
            </p>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default DeleteRunModal;
